
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from "@material-ui/core/styles/withStyles";


function setItemFontStyles(fontFamily: string,
  fontStyle: string,
  fontWeight: any,
  fontSize: string,
  lineHeight: string,
  color?: string): CSSProperties {
  return {
    fontFamily: fontFamily,
    fontStyle: fontStyle,
    fontWeight: fontWeight,
    fontSize: fontSize,
    lineHeight: lineHeight,
    color: color && color,
    margin:0
  }
}
export const useStyles = makeStyles((theme: IYoelloTheme) =>
  createStyles({
    ModalContainer:{
      "& .MuiDialog-paperWidthMd":{
        padding:0,
        margin:0,
        minWidth:"30rem!important",
      }
    },
    issueRefundContainer:{
      minWidth:"30rem",
      minHeight:"21.875rem",
      width: "43.75rem!important",
      marginBottom: "5rem",
      height: "calc(100% - 5rem)",
      overflowY: "auto",
      "@media only screen and (max-width: 767px)": {
        width: "100% !important",
      },
      "@media only screen and (max-width: 500px)": {
        minWidth:"25rem",
      },
      "@media only screen and (max-width: 400px)": {
        minWidth:"23rem!important",
      },
      "& >p":{
        ...setItemFontStyles("Open Sans","normal","normal","1.0625rem","1.4375rem","#455681")
      },
      "& >ul":{
        margin:0,
        marginTop:"1.5625rem",
        padding:0,
        "& >li":{
          listStyle:"none",
          width: "100%",
          padding:"0.9375rem 1.875rem",
          backgroundColor:"#F3F4F9",
          borderRadius:'0.625rem',
          display:"flex",
          flexDirection:"column",
          position: "relative",
          marginBottom:"0.9375rem",
          justifyContent:"center",
          cursor:"pointer",
          "& >p":{
            ...setItemFontStyles("Open Sans","normal","normal","1rem","1.375rem","#212121")
          },
          "&>div":{
            display:"flex",
            justifyContent:"space-between",
            "& >p:first-child":{
              ...setItemFontStyles("Open Sans","normal","normal","0.875rem","1.1875rem","#455681")
            },
            "& >p:last-child":{
              ...setItemFontStyles("Open Sans","normal","normal","0.9375rem","1.25rem","#455681")
            }
          }
        }
      }
    },
    selected:{
      backgroundColor: "#FAF6E0!important",
      border: "1.5px solid #FFDD02",
      "&::before":{
        content:"''",
        background: "#FFDD02",
        borderRadius: "12px",
        display: "inline-block",
        width: "5px",
        height: "12px",
        position: "absolute",
        left: "10px",
      }
    },
    InfoCard:{
      margintop:"1.875rem",
      padding:" 1.25rem 1.5625rem",
      background: "#F1F9FF",
      borderRadius: "0.75rem",
      marginBottom:"5rem",
      width: "100%",
      "& >header":{
        display: "flex",
        "& >p":{
          ...setItemFontStyles("Open Sans","normal",600,"0.9375rem","1.25rem","#212121"),
          paddingLeft: "0.625rem"
        }
      },
      "& >p":{
        ...setItemFontStyles("Open Sans","normal","normal","0.9375rem","1.625rem","#212121"),
        marginTop:"0.625rem"
      }
    },
    buttonsWrapper:{
      display:"flex",
      justifyContent:"flex-end",
      position: "absolute",
      left: 0,
      width: "100%",
      padding: "1.875rem 3.75rem",
      bottom: 0,
      background: "#FFFFFF",
    },
    ConfirmationModalContent:{
      padding:"1.875rem 5rem 0 5rem",
      flexDirection:"column",
      "& >p:first-child":{
        ...setItemFontStyles("Open Sans","normal","normal","0.9375rem","1.625rem","#212121"),
      },
      "& >p:last-child":{
        ...setItemFontStyles("Open Sans","normal",800,"0.9375rem","1.625rem","#212121"),
      }
    },
    ConfirmationModalBody:{
      backgroundColor:"#F3F4F9",
      "&>div:first-child":{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection:"column"
      }
    },
    ConfirmationModalHeader:{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "1.875rem 3.75rem",
      maxWidth:"25.375rem",
      margin:"auto",
      "&>div:first-child":{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection:"column",
        "&>div:first-child":{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection:"column",
          "& p":{
            ...setItemFontStyles("Open Sans","normal",600,"1rem","1.625rem"),
            margin:"1.25rem 0"
          }
        },
        "&>div:last-child":{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection:"column",
          "& >p:first-child":{
            ...setItemFontStyles("Open Sans","normal","normal","0.8125rem","1.125rem", "#455681"),
            marginBottom:"0.3125rem"
          },
          "& >p:last-child":{
            ...setItemFontStyles("Open Sans","normal",600,"1.25rem","1.6875rem","#212121"),
          }
        }
      },
      "&>div:last-child":{
        position:"absolute",
        top: "1rem",
        right: "2rem",
        "& svg":{
          fill:"#AAB6D3!important"
        }
      },

    },
    ConfirmationModalFooter:{
      padding:"1.5625rem 5rem 1.5625rem 5rem",
      display: "flex",
      justifyContent: "center",
    },
    CheckListRoot:{
      "@media only screen and (max-width: 500px)": {
        width: "100% !important",
        minWidth:"28rem",
        "&>div>div:last-child>div":{
          padding:"1.25rem 0.5rem!important"
        }
      },
      "@media only screen and (max-width: 400px)": {
        minWidth:"20rem!important",
      },
    },
    ToolbarContainer:{
      display:"flex",
      alignItems:"center",
      "&>p":{
        ...setItemFontStyles("Open Sans","normal","normal","1rem","1.375rem","#212121"),
        margin:"0 0.625rem",
      },
      "&>div:last-child":{
          ...setItemFontStyles("Open Sans","normal","normal","1rem","1.375rem","#212121"),
      }
    },
    ItemQuantitySelectWrapper:{
      position:"relative",
      "& >div":{
       display:"flex",
       alignItems:"center",
       justifyContent:"center",
       background:"#E8EAF4",
       borderRadius:"6px",
       transition: "rotate 1s",
       padding:"0.3125rem 0.9375rem",
       flexDirection:"row-reverse",
       "& >p":{
         ...setItemFontStyles("Open Sans","normal","normal","1rem","1.375rem","#424242"),
         paddingRight:"1.25rem",
       }
      }
     },
     SelectedQuantity:{
      background:"#FFFFFF!important",
      border:"0.5px solid #FFDD02!important",
      "& svg":{
        transform: "rotate(-180deg)"
      }
     },
     ItemQuantitySelectOptions:{
      position:"absolute",
      background: "#FFFFFF",
      boxShadow: "0px 4px 20px rgba(33, 33, 33, 0.15)",
      borderRadius: "8px",
      marginTop: "0.3125rem",
      right: 0,
      padding:0,
      listStyle:"none",
      minWidth:"4.3125rem",
      zIndex:999,
      maxHeight:"5rem",
      overflowY:"auto",
      "& >li":{
        "& >p":{
          ...setItemFontStyles("Open Sans","normal","normal","0.875rem","1.1875rem","#616161"),
          "&:hover":{
            color:"#000000!important"
          }
        },
        "&:hover":{
          backgroundColor:"#F3F4F9",
          borderRadius:"6px",
        },
        padding:"0.625rem 0.9375rem",
        margin:"0.3125rem",
        cursor:"pointer"
      }
    },
    totalRefundedPrice:{
      position:"absolute",
      bottom:"1.375rem",
      "& >p:first-child":{
        ...setItemFontStyles("Open Sans","normal","normal","0.875rem","1.1875rem","#455681"),
      },
      "& >p:last-child":{
        ...setItemFontStyles("Open Sans","normal",600,"1rem","1.375rem","#212121"),
      },
    },
    ItemContentWrapper:{
      height: "100%",
      "& >div": {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-around",
        "& >p": {
          ...setItemFontStyles("Open Sans","normal","normal","1.0625rem","1.4375rem","#212121"),
          whiteSpace: "nowrap",
          overflow:" hidden !important",
          textOverflow: "ellipsis",
          width:"350px",
          "@media only screen and (max-width: 767px)": {
            width:"220px!important",
          },
        },
        "& span": {
          ...setItemFontStyles("Open Sans","normal","normal","0.875rem","1.1875rem","#757575"),
          paddingTop: "0.3125rem",
          whiteSpace: "nowrap",
          overflow:" hidden !important",
          textOverflow: "ellipsis",
          width:"350px",
          "@media only screen and (max-width: 767px)": {
            width:"220px!important",
          },
        }
      },
    },
    Disabled:{
      color: "rgba(0, 0, 0, 0.26)!important",
      boxShadow: "none !important",
      backgroundColor: "rgba(0, 0, 0, 0.12)!important",
    },
    ChekListInfoCard:{
      position:"absolute",
      bottom:"6rem",
      right:0,
      left:0,
      margin:"0 2rem",
      "&>div":{
        marginBottom:"0!important"
      }
    },
    ConfirmationModalTitle:{
      textAlign:"center",
      paddingTop:"1rem"
    }
  }),
);